"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var I18n = require("i18n-js");
function OfferListingSellerCost(props) {
    if (!props.sellerCostDisplay) {
        return null;
    }
    return (React.createElement("div", { className: "modal-sidebar-listing__detail" },
        React.createElement("dt", null, I18n.t('discovery.offers.sellerCost')),
        React.createElement("dd", null, props.sellerCostDisplay)));
}
exports.default = OfferListingSellerCost;
//# sourceMappingURL=offer_listing_seller_cost.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/offers/offer_listing_seller_cost.js
// module id = uIRx
// module chunks = 20 21